import { Separator } from '@chakra-ui/react';

const VSeparator = (props) => <Separator {...props} />;

export default VSeparator;
